export enum ViewMode {
  View,
  Edit,
  New
}
